import {
	USER_LIBRARY,PUBLIC_LIBRARIES
} from '../actions/ActionTypes';

const initialState = {
	 myLibrary: [],
	 publicLibraries:[],
	 approvedLibraries:[],
	 pendingLibraries:[]
 };
export default function (state = initialState, action) {
	switch (action.type) {
		case USER_LIBRARY:
			return {
				...state,
				myLibrary: action.data,	
				approvedLibraries:action.approvedLibraries,
				pendingLibraries:action.pendingLibraries				
			};
		case PUBLIC_LIBRARIES:
			return {
				...state,
				publicLibraries: action.data,	
				
			};
		   default:
			return state;
	}
}

